import React, {useState, useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import {ListGroup, Spinner, Button, Alert} from "react-bootstrap";
import * as t from "counterpart";
import api from "../../utilities/API";
import {paymentRedirection} from "./actions";
import "./style/Shipping.scss"

function Shipping()
{
	const {store, id} = useParams();
	const navigate = useNavigate();
	const [method, setMethod] = useState(null);
	const [selectedRate, setSelectedRate] = useState(null);
	const [feedback, setFeedback] = useState({});

	useEffect(() => {
		api("/commerce/orders/"+id+"/shipping", {
			result: data => {
				(data.rates || []).sort((a, b) => (a.total > b.total) ? 1 : -1);
				setMethod(data);
				setFeedback({});
			},
			error: error => setFeedback({error}),
		})
	}, [id]);

	//
	const setOrderShipping = () =>
	{
		setFeedback({loading: true});

		api("commerce/orders/"+id+"/checkout", {
			method: "PUT",
			data: {rate: selectedRate},
			result: (res) => {
				setFeedback({});
				paymentRedirection(res.data, navigate, store);
			},
			error: (error) => setFeedback({error}),
		})
	}

	return (
		<div id="cart-shipping-page" className="container page-body">
			<h1><i className="fa fa-shopping-cart" />{t("Delivery Method")}</h1>

			{feedback.error && <Alert variant="danger">{feedback.error}</Alert>}
			{!method && !feedback.error && <Spinner animation="border" size="xl" />}
			{method && <div>
				<ListGroup>
					{(method.rates || []).map(rate =>
						<ListGroup.Item className="method" action key={method.id+"-"+rate.courier_type}
							onClick={() => setSelectedRate(rate.courier_type)} >
							<input type="radio" checked={rate.courier_type === selectedRate}/>
							<div><img src={"/assets/shipping/"+rate.courier_code+".svg"} alt=""/> {rate.courier_name}</div>
							<div className="cost">{rate.total + " "+window.portalSetting("commerce.currency")}</div>
						</ListGroup.Item>
					)}
				</ListGroup>

				<Button id="continue" disabled={!selectedRate || feedback.loading} onClick={setOrderShipping} load>
					<i className="fa fa-money-bill" /> {t("Confirm and Continue")}
				</Button>
			</div>}
		</div>
	);
}

export default Shipping;
